import axiosInstance from './axiosInstance';
import { ENDPOINTS } from './endpoints';
import { dedupe } from './dedupe';

export const loginApi = (data) => axiosInstance.post(ENDPOINTS.LOGIN, data);
export const registerApi = (data) => axiosInstance.post(ENDPOINTS.REGISTER, data);
export const profileApi = () => dedupe('profile', () => axiosInstance.get(ENDPOINTS.PROFILE));
